import type { MonitoringUnitsTrendPoint } from "../../../shared/monitoringWorkflowsReport";
import { PERSONAL_BUCKET } from "./monitoringScope";

export const UNATTRIBUTED_UNITS_BUCKET = "__unattributed__";

export function buildTinesUnitsBySpaceRows({
  usage,
  matchesSpace,
  personalIds,
  foldPersonal,
  spaceLabels,
}: {
  usage: Readonly<MonitoringUnitsTrendPoint["spaces"]>;
  matchesSpace: (spaceId: string | null) => boolean;
  personalIds: ReadonlySet<string>;
  foldPersonal: boolean;
  spaceLabels: ReadonlyMap<string, string>;
}) {
  const rowsById = new Map<
    string,
    { key: string; label: string; total: number }
  >();
  for (const row of usage) {
    if (!matchesSpace(row.spaceId) || row.total <= 0) continue;
    const personal =
      row.spaceId != null && foldPersonal && personalIds.has(row.spaceId);
    const key = personal
      ? PERSONAL_BUCKET
      : (row.spaceId ?? UNATTRIBUTED_UNITS_BUCKET);
    const label = personal
      ? "Personal"
      : row.spaceId == null
        ? "Unattributed"
        : (spaceLabels.get(row.spaceId) ?? "Deleted space");
    const entry = rowsById.get(key);
    if (entry) entry.total += row.total;
    else rowsById.set(key, { key, label, total: row.total });
  }
  const rows = [...rowsById.values()].sort(
    (a, b) => b.total - a.total || a.label.localeCompare(b.label)
  );
  return {
    rows,
    total: rows.reduce((sum, row) => sum + row.total, 0),
    max: Math.max(1, ...rows.map((row) => row.total)),
  };
}
